"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.assign");

var _storage = _interopRequireDefault(require("../../utils/storage"));

var _rootLocalStore = _interopRequireDefault(require("../../utils/rootLocalStore"));

var _rootMemoryBuffer = _interopRequireDefault(require("../../utils/rootMemoryBuffer"));

var _constants = require("../../constants");

var _config = require("../../utils/config");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

var storage = function storage(next) {
  return function (params) {
    var data = params.data,
        others = _objectWithoutProperties(params, ["data"]); // 在存数据的时候，将每条数据的 serviceId 写入此条数据，再发送请求的时候带上
    // 防止同域名下多服务数据缓存窜用


    var _getConfig = (0, _config.getConfig)(),
        serviceId = _getConfig.serviceId;

    var mergeData = _objectSpread({}, data, {
      serviceId: serviceId
    });

    _rootMemoryBuffer.default.addData(mergeData);

    _rootLocalStore.default.addData(mergeData).then(function (count) {
      // 离线存储成功
      next(Object.assign({}, params, {
        dataCount: count
      }));
    }, function () {
      // 离线存储失败
      next(Object.assign({}, params, {
        isSaveFailed: true
      }));
    });

    _storage.default.setItem(_constants.SENTRY_CONFIG, others);
  };
};

var _default = storage;
exports.default = _default;